const s = (t) => {
  if (t instanceof HTMLElement && t.getAttribute("data-attrs")) {
    const { uid: a, ...r } = JSON.parse(
      t.getAttribute("data-attrs") ?? "{}"
    );
    return r;
  }
};
export {
  s as getAttrs
};
